import React from 'react';
import { SVG } from './NoAlertsSVG.js';
/**
 * This SVG will be deprecated, use NoAlertsSVG instead!
 */
export function AllGoodSVG(props) {
    return React.createElement(SVG, { title: "All Good", ...props });
}
//# sourceMappingURL=AllGoodSVG.js.map